import React from "react";

import { Input } from "~/components/input";
import { RadioButtonGroup } from "~/components/radio-button-group";
import { RadioButtonGroupItem } from "~/components/radio-button-group/item";
import { useScope } from "~/tools/impulse";
import type { Record } from "~/tools/record";

import {
	type WidgetThresholdModeVariant,
	WidgetThresholdsMode,
	WidgetThresholdsStep,
	type WidgetThresholdsValue,
} from "./form-state";

export interface WidgetThresholdsValueFieldProps {
	value: WidgetThresholdsValue;
	name: string;
	onBlur?: VoidFunction;
}

export const WidgetThresholdsValueField: React.FC<WidgetThresholdsValueFieldProps> = ({ value, name, onBlur }) => {
	const scope = useScope();

	return (
		<Input
			name={name}
			onBlur={onBlur}
			onChange={(event) => {
				value.setInput(event.target.value);
			}}
			placeholder={WidgetThresholdsStep.fallback.value.toString()}
			type="number"
			value={value.getInput(scope)}
		/>
	);
};

const THRESHOLD_MODES_TO_LABEL = {
	absolute: "Absolute",
	percent: "Percent",
} satisfies Record<WidgetThresholdModeVariant>;

export interface WidgetThresholdsModeFieldProps {
	className?: string;
	disabled?: boolean;
	name: string;
	mode: WidgetThresholdsMode;
}

export const WidgetThresholdsModeField: React.FC<WidgetThresholdsModeFieldProps> = ({
	className,
	disabled,
	mode,
	name,
}) => {
	const scope = useScope();

	return (
		<RadioButtonGroup
			className={className}
			onValueChange={(value) => mode.setInput(value)}
			value={mode.getInput(scope)}
		>
			{WidgetThresholdsMode.all.map((thresholdMode) => (
				<RadioButtonGroupItem disabled={disabled} key={thresholdMode} name={name} value={thresholdMode}>
					{THRESHOLD_MODES_TO_LABEL[thresholdMode]}
				</RadioButtonGroupItem>
			))}
		</RadioButtonGroup>
	);
};
